module.exports = __webpack_public_path__ + "img/tour-24.71366d77.png";